export default __webpack_public_path__ + "static/media/social-icon.ca896f89.svg";